import produce from 'immer'

const initialStateUpdater = {
    serviceWorkerUpdated: false,
    serviceWorkerRegistration: null
}

export const reducer = produce((draft, action) => {
    if (action.type === 'SW_UPDATE') {
        draft.serviceWorkerUpdated = true
        draft.serviceWorkerRegistration = action.payload
    }
}, initialStateUpdater)

const deRoot = (state) => state.updater

export const selectServiceWorkerUpdated = (state) => deRoot(state).serviceWorkerUpdated
export const selectServiceWorkerRegistration = (state) => deRoot(state).serviceWorkerRegistration
